import { Maybe, Media } from 'graphql.generated';

export const AdditionalLinkDefaults: { [key: string]: string } = {
    brochure: 'Brochure',
    document: 'Document',
    hip: 'Home report',
    map: 'Map',
    site_plan: 'Site plan'
};

export type AdditionalLinksProps = {
    data: AdditionalLinksFragment;
};

export type AdditionalLinksFragment = {
    additionalLinks: Maybe<Array<Media>>;
};

export type AdditionalLink = {
    href: string;
    label: string;
};
